module.exports = __webpack_public_path__ + "assets/img/swiper-2-2.7bb25da0.jpg";